import React, { useState } from 'react';
import Loader from 'examples/Loader';
import Prompts from './Prompts';
import { SUPER_ADMIN_OWNER_AGENCY_ID } from './superAdminAgency';
import { usePartnerTasks, useAdminPromptCategories, useAvailableBranding } from 'queries/prompts';
import { useAgencyById } from 'queries/agency';

// Flat list of super-admin-authored tasks, mirroring agencyiframe's Partner Tasks
// screen (UiPrompts/customPrompts/CustomPrompt.js + Prompts.js): role/sector/search
// filters above one card per task, each with edit, delete and an active toggle.
// Fetched with type=SuperAdmin, so agency-authored tasks — which share the same
// collection — never show up here.
function AdminPrompt() {
  const [roleFilter, setRoleFilter] = useState('all');
  const [sectorFilter, setSectorFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [createOpen, setCreateOpen] = useState(false);

  const {
    data: tasks = [],
    isLoading: tasksLoading,
    refetch: refetchTasks,
  } = usePartnerTasks({ agencyId: 'superYxadminagency_id', type: 'SuperAdmin' });

  const { data: categoriesList = [], isLoading: categoriesLoading } = useAdminPromptCategories();

  const toOption = (item) => ({ value: item._id || item.id, label: item.name });
  const { data: agencyData, isLoading: rolesLoading } = useAgencyById(SUPER_ADMIN_OWNER_AGENCY_ID);
  const jobRolesList = (agencyData?.job_roles || []).map(toOption);
  const sectorsList = (agencyData?.sectors || []).map(toOption);

  const { data: integrationsList = [], isLoading: integrationsLoading } = useAvailableBranding();

  const loading = tasksLoading || categoriesLoading || rolesLoading || integrationsLoading;

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <Prompts
            tasks={tasks}
            refresh={refetchTasks}
            roleFilter={roleFilter}
            sectorFilter={sectorFilter}
            searchQuery={searchQuery}
            jobRolesList={jobRolesList}
            sectorsList={sectorsList}
            categoriesList={categoriesList}
            integrationsList={integrationsList}
          />
        </div>
      )}
    </div>
  );
}

export default AdminPrompt;
